export default __webpack_public_path__ + "static/media/cloudyflight.1e29ff14.md";